import Vue from "vue";
import VueRouter from "vue-router";
import userRouter from "@/modules/user/router";
import adminRouter from "@/modules/admin/router";
import profesorRouter from "@/modules/profesor/router";
import { decifraToken } from "@/modules/shared/functions";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/modules/user/views/LoginUserView.vue"),
  },
  {
    path: "/admin",
    name: "login-admin",
    component: () => import("@/modules/admin/views/LoginAdminView.vue"),
  },
  {
    path: "/profesor",
    name: "profesor",
    component: () => import("@/modules/profesor/views/ProfesorLoginView.vue"),
  },

  {
    path: "/validaConstancia",
    name: "constancia",
    component: () =>
      import("@/modules/constancia/views/DatosConstanciaView.vue"),
  },
  /// 
{
    path: "/php/constancia.php",
    name: "constancia-php",
    component: () =>
      import("@/modules/constancia/views/CargaConstanciaView.vue"),
  },

  {
    path: "/recuperar-password",
    name: "recuperar-password",
    component: () => 
      import("@/modules/admin/views/RecuperarPasswordView.vue"),
  },
  {
    path: "/alumno",
    ...userRouter,
    beforeEnter: (to, from, next) => {
      if (!sessionStorage.getItem("token")) {
        sessionStorage.clear();
        next("/");
        return;
      }
      let userRoles = ["AI", "AU", "EX"];
      let data = decifraToken(sessionStorage.getItem("token"));
      if (userRoles.includes(data?.tipoUsuario)) {
        next();
      } else {
        sessionStorage.clear();
        next("/");
        return;
      }
    },
  },

  {
    path: "/admin",
    ...adminRouter,
    beforeEnter: (to, from, next) => {
      if (!sessionStorage.getItem("token")) {
        sessionStorage.clear();
        next("/admin");
        return;
      }
      let userRoles = ["A", "S"];
      let data = decifraToken(sessionStorage.getItem("token"));
      if (userRoles.includes(data?.tipoUsuario)) {
        next();
      } else {
        sessionStorage.clear();
        next("/admin");
        return;
      }
    },
  },

  {
    path: "/profesor",
    ...profesorRouter,
    beforeEnter: (to, from, next) => {
      if (!sessionStorage.getItem("token")) {
        sessionStorage.clear();
        next("/profesor");
        return;
      }
      let userRoles = ["P"];
      let data = decifraToken(sessionStorage.getItem("token"));
      if (userRoles.includes(data?.tipoUsuario)) {
        next();
      } else {
        sessionStorage.clear();
        next("/profesor");
        return;
      }
    },
  },

  {
    path: "*",
    name: "PageNotFound",
    component: () => import("@/components/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
